// Types
import * as types from "redux/actiontypes/ui-types";

const showSnackbar = (bool) => ({ type: types.SHOW_SNACKBAR, payload: bool });

export { showSnackbar };
